export const authEN = {
 title: "Your health, your private space",
 description: "Sign in securely with your Keycloak account to access your records, therapies and reports.",
 login: "Sign in with Keycloak", switchAccount: "Sign out of Keycloak to switch accounts", logout: "Sign out", loading: "Checking your session…",
 failed: "Sign-in could not be completed. Please try again.",
 denied: "Your account does not have access to Health Tracker. Contact your administrator.",
 unavailable: "The sign-in service is unavailable. Check your connection and try again.",
 retry: "Try again", account: "Account", signedIn: "Signed in securely", development: "Local development · authentication disabled",
 expired: "Your session has ended. Sign in again to continue.", logoutFailed: "Could not sign out. Please try again.",
};
export const authHR = {
 title: "Vaše zdravlje, vaš privatni prostor",
 description: "Prijavite se sigurno svojim Keycloak računom za pristup zapisima, terapijama i izvještajima.",
 login: "Prijava putem Keycloaka", switchAccount: "Odjava iz Keycloaka za promjenu računa", logout: "Odjava", loading: "Provjera prijave…",
 failed: "Prijavu nije moguće dovršiti. Pokušajte ponovno.",
 denied: "Vaš račun nema pristup aplikaciji Health Tracker. Obratite se administratoru.",
 unavailable: "Usluga prijave nije dostupna. Provjerite vezu i pokušajte ponovno.",
 retry: "Pokušaj ponovno", account: "Račun", signedIn: "Sigurna prijava", development: "Lokalni razvoj · autentifikacija isključena",
 expired: "Vaša je sesija završila. Ponovno se prijavite za nastavak.", logoutFailed: "Odjava nije uspjela. Pokušajte ponovno.",
};
